import {
  SET_GOOGLE_APPLE_PAY,
  SET_PROCESSING_ORDER,
  TOGGLE_PAYMENT_PROCESSING_MODAL,
} from "./actions"

const INITIAL_STATE = {
  canProcessApplePay: null,
  canProcessGooglePay: null,
  processingOrder: false,
  showPaymentProcessingModal: false,
}

export default function cartUIReducer(state = INITIAL_STATE, action) {
  let newState = Object.assign({}, state)

  switch (action.type) {
    case SET_GOOGLE_APPLE_PAY:
      return {
        ...state,
        canProcessApplePay: action.applePay,
        canProcessGooglePay: action.googlePay,
      }
    case SET_PROCESSING_ORDER:
      newState.processingOrder = action.set
      return newState

    case TOGGLE_PAYMENT_PROCESSING_MODAL:
      newState.showPaymentProcessingModal = action.toggle
      return newState
    default:
      return state
  }
}
